// string constants
var TEXT_MORE = "more";
var TEXT_LESS = "less";

export { TEXT_LESS, TEXT_MORE };
//# sourceMappingURL=constants.esm.js.map
